import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

// -- פריט בודד — שורה פשוטה ---------------------------------------------------
const ItemRow = ({ item }) => {
  const isHighPriority = item.priority === 'high';

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: 1,
      py: 0.35,
      px: 0.75,
      borderBottom: '1px solid #f1f5f9',
      borderRight: isHighPriority ? '2px solid #8a6d08' : '2px solid transparent',
      '&:last-child': { borderBottom: 'none' },
    }}>
      <Typography sx={{
        fontFamily: 'Frank Ruhl Libre, David, serif',
        fontSize: '0.72rem',
        fontWeight: isHighPriority ? 700 : 500,
        color: isHighPriority ? '#1e293b' : '#475569',
        lineHeight: 1.4,
        flex: 1,
        minWidth: 0,
      }}>
        {item.label}
      </Typography>
      {item.value && (
        <Typography sx={{
          fontFamily: 'Frank Ruhl Libre, David, serif',
          fontSize: '0.68rem',
          color: isHighPriority ? '#1e3a5f' : '#64748b',
          fontWeight: isHighPriority ? 600 : 400,
          lineHeight: 1.4,
          flexShrink: 0,
          whiteSpace: 'nowrap',
        }}>
          {item.value}
        </Typography>
      )}
    </Box>
  );
};

// -- יום lookahead בודד --------------------------------------------------------
const LookaheadDay = ({ dayData }) => (
  <Box sx={{ mt: 1.25, pt: 1, borderTop: '1px dashed #e2e8f0' }}>
    <Typography sx={{
      fontFamily: 'Frank Ruhl Libre, David, serif',
      fontSize: '0.65rem',
      fontWeight: 700,
      color: '#1e3a5f',
      textAlign: 'center',
      mb: 0.5,
    }}>
      {dayData.hebrewDate?.hebrew || dayData.date}
    </Typography>
    {dayData.items.length === 0 ? (
      <Typography sx={{
        fontFamily: 'Frank Ruhl Libre, David, serif',
        fontSize: '0.62rem',
        color: '#94a3b8',
        textAlign: 'center',
      }}>
        ---
      </Typography>
    ) : (
      dayData.items.map((item, i) => (
        <ItemRow key={item.id || i} item={item} />
      ))
    )}
  </Box>
);

// == תבנית קומפקטית ============================================================
const Compact = ({
  today,
  items,
  lookaheadItems,
  lookaheadDays,
  loading,
  error,
  title,
  showTitle,
}) => {
  const hebrewDateStr = today?.hebrewDate?.hebrew || '';

  return (
    <Box sx={{
      background: '#ffffff',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      direction: 'rtl',
      overflowY: 'auto',
      padding: '8px 10px',
      '&::-webkit-scrollbar': { width: 2 },
      '&::-webkit-scrollbar-thumb': { background: '#e2e8f0', borderRadius: 1 },
    }}>
      {/* כותרת */}
      {showTitle && (
        <Typography sx={{
          fontFamily: 'Frank Ruhl Libre, David, serif',
          fontSize: '0.6rem',
          color: '#94a3b8',
          letterSpacing: '0.12em',
          textAlign: 'center',
          mb: 0.15,
        }}>
          {title}
        </Typography>
      )}

      {/* תאריך עברי */}
      {hebrewDateStr && (
        <Typography sx={{
          fontFamily: 'Frank Ruhl Libre, David, serif',
          fontSize: '0.72rem',
          fontWeight: 700,
          color: '#1e3a5f',
          textAlign: 'center',
          mb: 0.75,
        }}>
          {hebrewDateStr}
        </Typography>
      )}

      {/* loading */}
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 0.5 }}>
          <CircularProgress size={14} sx={{ color: '#94a3b8' }} />
        </Box>
      )}

      {/* error */}
      {error && (
        <Typography sx={{
          fontSize: '0.62rem',
          color: '#ef4444',
          textAlign: 'center',
          mb: 0.5,
        }}>
          שגיאה
        </Typography>
      )}

      {/* פריטים */}
      {(!items || items.length === 0) && !loading && (
        <Typography sx={{
          fontFamily: 'Frank Ruhl Libre, David, serif',
          fontSize: '0.65rem',
          color: '#94a3b8',
          textAlign: 'center',
          mt: 1,
        }}>
          אין ענייני יום מיוחדים
        </Typography>
      )}

      {items && items.map((item, i) => (
        <ItemRow key={item.id || i} item={item} />
      ))}

      {/* ימי lookahead */}
      {lookaheadDays > 0 && lookaheadItems && lookaheadItems.length > 0 && (
        lookaheadItems.map((dayData, i) => (
          <LookaheadDay key={dayData.date || i} dayData={dayData} />
        ))
      )}
    </Box>
  );
};

export default Compact;
